"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useScrollTrigger.default;
  }
});

var _useScrollTrigger = _interopRequireDefault(require("./useScrollTrigger"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/useScrollTrigger/index.js
// module id = 762
// module chunks = 0